import { ComponentProps, ReactNode } from 'react';
import { useSelector } from '@tanstack/react-form';
import { Button } from '@Components/Button';
import { useFormContext } from './form-field-utils';

interface SubmitButtonProps extends Omit<ComponentProps<typeof Button>, 'onClick' | 'loading'> {
  requireChanges?: boolean;
}

export const SubmitButton = ({
  disabled = false,
  requireChanges = false,
  ...buttonPassthroughProps
}: SubmitButtonProps): ReactNode => {
  const form = useFormContext();
  const canSubmit = useSelector(form.store, state => state.canSubmit);
  const isSubmitting = useSelector(form.store, state => state.isSubmitting);
  const isDefaultValue = useSelector(form.store, state => state.isDefaultValue);

  return (
    <Button
      {...buttonPassthroughProps}
      disabled={disabled || !canSubmit || (requireChanges && isDefaultValue)}
      loading={isSubmitting}
      onClick={() => form.handleSubmit()}
    />
  );
};
